import React, { ReactElement, useEffect } from 'react';
import { Location, useLocation } from 'react-router-dom';

/*
 * Taken from https://v5.reactrouter.com/web/guides/scroll-restoration
 */
export default function ScrollToTop(): ReactElement {
    const location: Location = useLocation();
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [
        location.pathname,
    ]);

    return null;
};

